import { baseApi } from '@/api';
import config from '@/config';
import get from 'lodash/get';

import { IParamsUpdateActivities } from './activities.d';

export const getActivities = async (id?: string, page?: number) => {
  if (!id || !page) return;
  let response;
  try {
    response = await baseApi.get(config.API_ACTIVITIES_PATH.ACTIVITIES, {
      params: {
        sessionId: id,
        page,
        take: 10,
      },
    });
  } catch (e) {
    throw get(e, 'response.data');
  }
  return response;
};

export const updateActivities = async (data: IParamsUpdateActivities) => {
  console.log('updateActivities ---->', data);
  if (!data.sessionId) return;
  let response;
  try {
    response = await baseApi.post(config.API_ACTIVITIES_PATH.ACTIVITIES, {
      ...data,
    });
  } catch (e) {
    throw get(e, 'response.data');
  }
  return response;
};
